import React from "react";
import axios from "axios";
import * as IoIcons from "react-icons/io";
import Swal from "sweetalert2";
function EliminarNorma(props) {
  const Eliminar = (e) => {
    e.preventDefault(e);
    axios({
      auth: { username: "webapp", password: "762tsfsy9826kk87ytttsf" },
      method: "delete",
      url:
        "https://autodiagnosticoback.azurewebsites.net/api/EliminaNorma/" +
        props.id,
      data: {},
    })
      .then((Response) => {
        Swal.fire({
          title: Response.data,
          icon: "success",
          buttons: true,
          dangerMode: true,
        }).then((willDelete) => {
          if (willDelete) {
            console.log(Response.data);

            window.location.reload("/");
          } else {
            Swal.fire("Your imaginary file is safe!");
          }
        });
      })
      .catch((error) => {
        console.log(error);
        Swal.fire({
          title: "No se puedo eliminar",
          text: "Intentelo de nuevo",
          icon: "error",
        });
      });
  };
  return (
    <div>
      <button
        variant="contained"
        className="btn btn-danger"
        color="primary"
        onClick={Eliminar}
      >
        {" "}
        <IoIcons.IoIosCloseCircle />{" "}
      </button>
    </div>
  );
}

export default EliminarNorma;
